import { Component, Input } from '@angular/core';
import { MessageService } from 'src/app/services/message.service';
import { Clipboard } from '@angular/cdk/clipboard';

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss'],
})
export class AccountComponent {
  @Input() text = '';

  constructor(private clipboard: Clipboard, private message: MessageService) {}

  copy() {
    this.clipboard.copy(this.text);
    this.message.open('已复制');
  }
}
